/**
 * VendorProductService
 * Service for managing vendor products with view endpoints
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product CRUD operations with view endpoints
 */
export class VendorProductService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all vendor product views
     * @returns Array of vendor product model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all vendor product views with full response
     * @returns ResponseData with array of vendor product model views
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get filtered vendor product list with pagination
     * @param filter - Optional filter parameters
     * @returns Paginated vendor product list response
     */
    async listView(filter) {
        const response = await this.listViewRaw(filter);
        if (!response.data) {
            return {
                products: [],
                totalCount: 0,
                page: filter?.page ?? 1,
                pageSize: filter?.pageSize ?? 20,
                activeCount: 0,
                draftCount: 0,
                inactiveCount: 0,
                featuredCount: 0,
                averagePrice: 0,
                minPrice: 0,
                maxPrice: 0,
            };
        }
        return response.data;
    }
    /**
     * Get filtered vendor product list with pagination and full response
     * @param filter - Optional filter parameters
     * @returns ResponseData with paginated vendor product list
     */
    listViewRaw(filter) {
        const url = this.buildUrl('list-view');
        return this.http.post(url, filter);
    }
    /**
     * Get vendor product view by ID
     * @param id - Product ID
     * @returns Vendor product model view
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Vendor product view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get vendor product view by ID with full response
     * @param id - Product ID
     * @returns ResponseData with vendor product model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
    /**
     * Get vendor product detail view by ID
     * @param id - Product ID
     * @returns Vendor product detail model view with variants, media, and rules
     */
    async getDetail(id) {
        const response = await this.getDetailRaw(id);
        if (!response.data) {
            throw new Error(`Vendor product detail view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get vendor product detail view by ID with full response
     * @param id - Product ID
     * @returns ResponseData with vendor product detail model view
     */
    getDetailRaw(id) {
        const url = this.buildUrl(`${id}/detail`);
        return this.http.get(url);
    }
}
VendorProductService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductService.BASE_PATH = 'api/vendor-products';
//# sourceMappingURL=VendorProductService.js.map